/* global Homie */

import axios from 'axios';
import HomeExistenceValidator from '../../onboarding/mixins/HomeExistenceValidator';
export default {
    template: '#auth-email',
    data() {
        return {
            current_email: Homie.user.email,
            email: Homie.user.email,
            code_send: false,
            error: false,
            message: false,
            next_step: ''
        }
    },
    mounted() {
        this.next_step = Homie.steps.filter(step_fil => {
            return step_fil.name == this.$route.name
        })[0].next;
    },
    computed: {
        isOriginal() {
            return this.current_email == this.email;
        }
    },
    methods: {
        sendConfirmationCode() {
            this.error = false;
            let data = {
                grant_type: 'email',
                value: this.email
            };
            axios.post('/verifications', data)
            .then(response => {
                this.code_send = true;
                this.message = response.data.message;
                this.$router.push({name: this.next_step});
            })
            .catch(error => {
                this.error = error.response.data.message;
            });
        }
    },
    mixins: [HomeExistenceValidator]
}